import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 750,
    },
  },
  theme: {
    themes: {
      light: {
        primary: '#FBF8F1',
        accent: '#F7ECDE',
        darker: '#E9DAC1',
        secondary: '#54BAB9',
      },
    },
  },
  treeShake: true,
  // defaultAssets: {
  //   font: {
  //     family: 'Roboto',
  //   },
  // },
});
